export const environment = {
  production: false,

  redApi: 'https://dev.v2.urbassist.fr/api',
  publicApi: 'https://api-dev.urbassist.app',
  authUrl: 'https://api-dev.urbassist.app/identity/oauth',
};
